import { functions } from '@/core/firebase'
import { httpsCallable } from 'firebase/functions'
import { showLoading, hideLoading } from '@/core/ui'

// --- [JOB_15] THIS IS THE FIX ---
// This "guard" ensures that even if initializeBrandManagement()
// is called 100 times, the click listener is only attached *once*.
let hasListenerBeenAttached = false
// --- [END FIX] ---

/**
 * Initializes the event listener for the "Create Brand" form.
 */
export function initializeBrandManagement(): void {
  // --- [JOB_15] THE GUARD CHECK ---
  if (hasListenerBeenAttached) {
    console.warn('[BrandManagement] Listener already attached. Skipping.')
    return // <-- Do nothing if we've already run.
  }
  // --- [END GUARD CHECK] ---

  const form = document.getElementById('create-brand-form')
  if (!form) {
    console.error('[BrandManagement] ERROR: "create-brand-form" not found.')
    return
  }

  const submitBtn = document.getElementById('create-brand-submit-btn') as HTMLButtonElement
  const brandNameInput = document.getElementById('brand-name-input') as HTMLInputElement
  const feedbackEl = document.getElementById('create-brand-feedback')

  if (!submitBtn || !brandNameInput || !feedbackEl) {
    console.error('[BrandManagement] ERROR: Form elements not found!')
    return
  }

  submitBtn.addEventListener('click', async () => {
    const brandName = brandNameInput.value.trim()
    if (!brandName) {
      feedbackEl.textContent = 'Please enter a brand name.'
      feedbackEl.className = 'p-3 text-sm rounded-md bg-red-100 text-red-800'
      feedbackEl.classList.remove('hidden')
      return
    }

    submitBtn.disabled = true
    submitBtn.textContent = 'Creating Brand...'
    showLoading({ message: 'Setting up your new brand...' })

    try {
      // Call the cloud function
      const createBrand = httpsCallable(functions, 'createBrand')
      await createBrand({ brandName })

      // Show success message
      feedbackEl.textContent = 'Brand created successfully! Reloading...'
      feedbackEl.className = 'p-3 text-sm rounded-md bg-green-100 text-green-800'
      feedbackEl.classList.remove('hidden')
      hideLoading()

      // Force a full page reload
      setTimeout(() => {
        window.location.reload()
      }, 1500)

    } catch (error: any) {
      console.error('Error creating brand:', error)
      feedbackEl.textContent = error.message || 'An unknown error occurred.'
      feedbackEl.className = 'p-3 text-sm rounded-md bg-red-100 text-red-800'
      feedbackEl.classList.remove('hidden')
      submitBtn.disabled = false
      submitBtn.textContent = 'Create Brand and Continue'
      hideLoading()
    }
  })
  
  // --- [JOB_15] SET THE GUARD FLAG ---
  // We've successfully attached the listener, so set the flag.
  hasListenerBeenAttached = true
  console.log('[BrandManagement] SUCCESS: Click listener attached.')
  // --- [END FIX] ---
}

/**
 * Manually shows the Brand Management view and hides all other
 * premium content views. This is the "gate" for new users.
 */
export function showBrandCreationGate(): void {
  // ... [this function remains unchanged] ...
  const brandManagementView = document.getElementById('brand-management-view')
  const allMainContent = document.querySelectorAll('.premium-analysis-content')
  
  allMainContent.forEach((el) => el.classList.add('hidden'))
  
  if (brandManagementView) {
    brandManagementView.classList.remove('hidden')
  }
}